import {
  faBaseballBall,
  faBeer,
  faWifi,
  faSwimmingPool,
  faDumbbell,
  faGolfBall,
  faConciergeBell,
  faGamepad,
  faChild,
  faUtensils,
  faBicycle,
  faRunning,
  faBaseball,
  faTableTennis,
  faMale,
  faDice,
  faGolfClub,
  faSkiing,
  faSpa,
  faRacquet,
  faHotTub,
  faForkKnife,
  faClockTwelve,
} from '@fortawesome/pro-duotone-svg-icons'

import events from '@layers/web/constants/events.js'

const faIcons = {
  faBaseballBall,
  faBeer,
  faWifi,
  faSwimmingPool,
  faDumbbell,
  faGolfBall,
  faConciergeBell,
  faGamepad,
  faChild,
  faUtensils,
  faBicycle,
  faRunning,
  faBaseball,
  faTableTennis,
  faMale,
  faDice,
  faGolfClub,
  faSkiing,
  faSpa,
  faRacquet,
  faHotTub,
  faForkKnife,
}

const faIconsMap = {
  'Receptionopen24/7': faClockTwelve,
}

export const useCharterHotelMixin = () => {
  const { supplierURLs } = useHotelImagesMixin()
  const { $event, $sentrySetContext, $sentryCaptureMessage } = useNuxtApp()
  const route = useRoute()
  const router = useRouter()
  const failed = ref(false)
  const emits = [events.hideModal, 'close']

  const { public: { images: imagesConfig } } = useRuntimeConfig()

  const images = (hotel) => {
    try {
      if (!hotel?.images) {
        if (hotel?.meta?.images2 && hotel.meta.images2.length > 0) {
          return (hotel.meta.images2 || [])
            .map(({ image, type }) => supplierURLs[type].replace('[PATH]', image))
        }

        if (!hotel?.meta?.images) {
          if (hotel?.image) {
            return [hotel.image]
          }

          if (hotel?.image_1) {
            const url = supplierURLs[hotel?.image_type]
            return [url.replace('[PATH]', hotel?.image_1)]
          }
        }
      }

      return (hotel?.images || hotel?.meta?.images || [])
        .filter(Boolean)
        .map((img) => {
          if (Array.isArray(img?.image)) {
            return img.image
          }

          const url = supplierURLs[img?.image_type || hotel?.meta?.images_type || hotel?.supplier] || ''
          return url.replace('[PATH]', img?.image || img)
        })
    } catch (e) {
      $sentrySetContext('exception', JSON.stringify(e))
      $sentryCaptureMessage('hotel images error', {
        level: 'warning',
        tags: {
          type: 'UX',
        },
      })
      return []
    }
  }

  const featuredImg = (hotel) => {
    const imgs = images(hotel)
    if (!imgs?.length) {
      return ''
    } else if (failed.value) {
      return imagesConfig.fallbackImage
    }
    return imgs[0]
  }

  const openHotel = (reviews = false, hotel) => {
    if (!route.query.showHotel) {
      const query = { ...route.query }
      query.showHotel = hotel.id
      if (reviews) {
        query.reviews = true
      }

      router.replace({ query }).catch(() => { })
    }
  }

  const closeHotel = () => {
    const { emit } = getCurrentInstance()

    if (route.query.showHotel) {
      const query = { ...route.query }
      delete query.showHotel
      delete query.reviews

      router.replace({ query }).catch(() => { })
    } else {
      $event.$emit(events.hideModal)
    }

    emit('close')
  }

  const getIcon = (icon) => {
    const iconClass = 'fa' + icon.trim().split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('')

    return faIcons[iconClass] || faIconsMap[icon] || ['fad', icon]
  }

  return {
    emits,
    images,
    featuredImg,
    openHotel,
    closeHotel,
    getIcon,
  }
}